import { LAYER_NAMES } from './layerNames';

//put clusters above points
export const CLUSTERED_POINTS_LAYER_ORDER = [
	//BOTTOM LAYER
	LAYER_NAMES.POINT_LAYER,
	LAYER_NAMES.CLUSTER_LAYER,
	//HOVER
	LAYER_NAMES.HOVERED_POINTS,
	//LAYER_NAMES.HOVERED_POINTS_TEXT,
	LAYER_NAMES.HOVERED_CLUSTERS,
	//LAYER_NAMES.CLUSTER_TEXT,
	//TOP LAYER
];
